import React from 'react';
import { skills } from '../mock';
import { Server, Shield, Brain } from 'lucide-react';

const Skills = () => {
  const skillCategories = [
    {
      title: 'DevOps Arsenal',
      icon: Server,
      skills: skills.devops,
      color: '#00FFD1'
    },
    {
      title: 'Cybersecurity Arsenal',
      icon: Shield,
      skills: skills.security,
      color: '#c80303ff'
    },
    {
      title: 'AI Arsenal',
      icon: Brain,
      skills: skills.ai,
      color: '#00FFD1'
    }
  ];

  return (
    <section id="skills" style={{
      minHeight: '100vh',
      padding: '160px 7.6923% 100px',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Section header */}
        <div style={{ marginBottom: '80px', textAlign: 'center' }}>
          <div style={{
            fontFamily: 'monospace',
            fontSize: '14px',
            color: '#00FFD1',
            marginBottom: '16px',
            letterSpacing: '2px'
          }}>
            {'>> CAPABILITY MATRIX'}
          </div>
          <h2 style={{
            fontSize: '48px',
            fontWeight: 600,
            lineHeight: 1.1,
            color: '#FFFFFF',
            marginBottom: '24px'
          }}>
            Weapon Systems
          </h2>
        </div>

        {/* Skills grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gap: '48px'
        }}>
          {skillCategories.map((category, catIndex) => {
            const Icon = category.icon;
            return (
              <div key={catIndex} style={{
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(0, 255, 209, 0.2)',
                padding: '40px',
                transition: 'all 0.4s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.border = '1px solid rgba(0, 255, 209, 0.5)';
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                e.currentTarget.style.transform = 'translateY(-8px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.border = '1px solid rgba(0, 255, 209, 0.2)';
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
              >
                {/* Category header */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '32px'
                }}>
                  <Icon size={28} style={{ color: category.color }} />
                  <h3 style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    color: '#FFFFFF',
                    fontFamily: 'monospace'
                  }}>
                    {category.title}
                  </h3>
                </div>

                {/* Skills with progress bars */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                  {category.skills.map((skill, index) => (
                    <div key={index}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '8px'
                      }}>
                        <span style={{
                          fontSize: '16px',
                          color: 'rgba(255, 255, 255, 0.9)',
                          fontFamily: 'monospace'
                        }}>
                          {skill.name}
                        </span>
                        <span style={{
                          fontSize: '14px',
                          color: category.color,
                          fontFamily: 'monospace',
                          fontWeight: 600
                        }}>
                          {skill.level}%
                        </span>
                      </div>
                      
                      {/* Progress bar */}
                      <div style={{
                        width: '100%',
                        height: '6px',
                        background: 'rgba(255, 255, 255, 0.1)',
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                        <div style={{
                          width: `${skill.level}%`,
                          height: '100%',
                          background: category.color,
                          boxShadow: `0 0 10px ${category.color}`,
                          transition: 'width 1s ease-out',
                          animation: 'progressPulse 2s ease-in-out infinite'
                        }} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional info */}
        <div style={{
          marginTop: '80px',
          padding: '48px',
          background: 'rgba(0, 255, 209, 0.05)',
          border: '1px solid rgba(0, 255, 209, 0.3)',
          textAlign: 'center'
        }}>
          <div style={{
            fontFamily: 'monospace',
            fontSize: '18px',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: 1.8
          }}>
            <span style={{ color: '#00FFD1', marginRight: '8px' }}>{'>'}</span>
            Expertise in building <span style={{ color: '#00FFD1' }}>enterprise-scale cloud infrastructure</span>,{' '}
            <span style={{ color: '#00FFD1' }}>AI-powered automation systems</span>, and{' '}
            <span style={{ color: '#00FFD1' }}>security research frameworks</span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes progressPulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }

        @media (max-width: 768px) {
          #skills > div > div:nth-child(2) {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Skills;